import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveBgImageUploadFromEndScreenSettingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveBgImageUploadFromEndScreenSettingMutation = { __typename?: 'RootMutationType', removeBgImageUploadFromEndScreenSetting?: { __typename?: 'EndScreenSettingResult', endScreenSetting?: { __typename?: 'EndScreenSetting', id: string, databaseId: any, title?: string | null, content?: string | null, textColor: string, blurEffect: number, bgType: Types.BackgroundType, bgGradientType: Types.GradientType, bgGradientAngle: number, showCta: boolean, ctaText?: string | null, ctaUrl?: string | null, ctaBgColor?: string | null, ctaTextColor?: string | null, bgImageUpload?: { __typename?: 'ImageUpload', id: string, imageUrl?: string | null } | null, colors: Array<{ __typename?: 'Color', r: number, g: number, b: number, a: number, hex: string }> } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string }> | null } | null };


export const RemoveBgImageUploadFromEndScreenSettingDocument = gql`
    mutation removeBgImageUploadFromEndScreenSetting($id: ID!) {
  removeBgImageUploadFromEndScreenSetting(id: $id) {
    endScreenSetting {
      id
      databaseId
      title
      content
      textColor
      blurEffect
      bgType
      bgGradientType
      bgGradientAngle
      bgImageUpload {
        id
        imageUrl
      }
      colors {
        r
        g
        b
        a
        hex
      }
      showCta
      ctaText
      ctaUrl
      ctaBgColor
      ctaTextColor
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type RemoveBgImageUploadFromEndScreenSettingMutationFn = Apollo.MutationFunction<RemoveBgImageUploadFromEndScreenSettingMutation, RemoveBgImageUploadFromEndScreenSettingMutationVariables>;

/**
 * __useRemoveBgImageUploadFromEndScreenSettingMutation__
 *
 * To run a mutation, you first call `useRemoveBgImageUploadFromEndScreenSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBgImageUploadFromEndScreenSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBgImageUploadFromEndScreenSettingMutation, { data, loading, error }] = useRemoveBgImageUploadFromEndScreenSettingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBgImageUploadFromEndScreenSettingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBgImageUploadFromEndScreenSettingMutation, RemoveBgImageUploadFromEndScreenSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBgImageUploadFromEndScreenSettingMutation, RemoveBgImageUploadFromEndScreenSettingMutationVariables>(RemoveBgImageUploadFromEndScreenSettingDocument, options);
      }
export type RemoveBgImageUploadFromEndScreenSettingMutationHookResult = ReturnType<typeof useRemoveBgImageUploadFromEndScreenSettingMutation>;
export type RemoveBgImageUploadFromEndScreenSettingMutationResult = Apollo.MutationResult<RemoveBgImageUploadFromEndScreenSettingMutation>;
export type RemoveBgImageUploadFromEndScreenSettingMutationOptions = Apollo.BaseMutationOptions<RemoveBgImageUploadFromEndScreenSettingMutation, RemoveBgImageUploadFromEndScreenSettingMutationVariables>;